import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nextProvider } from "react-i18next";
import { AuthProvider } from "@/contexts/AuthContext";
import { ConsoleAuthProvider } from "@/contexts/ConsoleAuthContext";
import { LocaleProvider } from "@/contexts/LocaleProvider";
import App from "@/App";
import i18n from "@/i18n";
import "@/index.css";

const APP_TITLE = "Restaurant ERP";

function removeEmergentBranding() {
  if (document.title.toLowerCase().includes("emergent")) {
    document.title = APP_TITLE;
  }
  document.getElementById("emergent-badge")?.remove();
  document.querySelectorAll('a[href*="emergent.sh"]').forEach((el) => el.remove());
  document.querySelectorAll(".debug-badge").forEach((el) => el.remove());
}

removeEmergentBranding();
if (typeof MutationObserver !== "undefined") {
  new MutationObserver(removeEmergentBranding).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ConsoleAuthProvider>
            <LocaleProvider>
              <App />
            </LocaleProvider>
          </ConsoleAuthProvider>
        </AuthProvider>
      </QueryClientProvider>
    </I18nextProvider>
  </React.StrictMode>,
);
